import { decorateConditions, stripConditions } from './conditionExpression';
export { decorateConditions, stripConditions, defaultConditionValue, conditionValid as rankingConditionValid, conditionExpressionValid as rankingExpressionValid, groupConditions as groupRankingConditions, removeCondition as removeRankingCondition, updateCondition as updateRankingCondition, ungroupConditions as ungroupRankingConditions, appendCondition as appendRankingCondition } from './conditionExpression';

export const emptyRankingWorkbench = () => ({
  id: null,
  revision: null,
  status: 'draft',
  name: '',
  note: '',
  conditions: decorateConditions(),
  factor: 2,
  boostedTermsText: '',
  midTermsText: '',
  validFrom: null,
  validTo: null,
});

export const rankingRuleToWorkbench = (rule) => ({
  id: String(rule.id),
  revision: Number(rule.revision),
  status: rule.status,
  name: String(rule.name || '').trim().toLowerCase() === 'product ranking rule'
    ? ''
    : (rule.name || ''),
  note: rule.description || '',
  conditions: decorateConditions(rule.conditions),
  factor: Number((rule.actions || []).find((action) => action.type === 'score.multiply')?.value || 1),
  boostedTermsText: (rule.actions || []).find((action) => (
    action.type === 'search_terms.add' && action.priority === 'boosted'
  ))?.terms?.join('\n') || '',
  midTermsText: (rule.actions || []).find((action) => (
    action.type === 'search_terms.add' && action.priority === 'mid'
  ))?.terms?.join('\n') || '',
  validFrom: rule.valid_from || null,
  validTo: rule.valid_to || null,
});

export const parseRankingSearchTerms = (text = '') => text.split(/\r?\n/)
  .map(term => term.trim()).filter(Boolean);

export const rankingSearchTermsValid = (text = '') => {
  const terms = parseRankingSearchTerms(text);
  return terms.length <= 32 && terms.every(term => term.length <= 100
    && !Array.from(term).some((character) => {
      const code = character.charCodeAt(0);
      return code < 32 || code === 127;
    }));
};

export const rankingWorkbenchRule = (model) => ({
  phase: 'index',
  kind: 'product_ranking',
  language_scope: 'neutral',
  document_type: 'product',
  ...(model.name.trim() ? { name: model.name.trim() } : {}),
  description: model.note.trim() || null,
  conditions: stripConditions(model.conditions),
  actions: [
    ...(Number(model.factor) !== 1
      ? [{ type: 'score.multiply', value: Number(model.factor) }] : []),
    ...(['boosted', 'mid'].flatMap((priority) => {
      const terms = parseRankingSearchTerms(model[`${priority}TermsText`] || '');
      return terms.length ? [{ type: 'search_terms.add', priority, terms }] : [];
    })),
  ],
  valid_from: model.validFrom || null,
  valid_to: model.validTo || null,
});
